import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import verifiedIcon from "../assets/Verified.svg";
import notVerifiedIcon from "../assets/Notverified.svg";
import { validateToken } from "../tokenValidation";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { FaSyncAlt, FaPlus } from "react-icons/fa";
import DocumentTypeOCR from "./documentOCRconfirm";
import { Dialog } from "primereact/dialog";
import { Menu } from "primereact/menu";
import { FaArrowLeft } from "react-icons/fa";
import secureStorage from "../utils/secureStorage";
const Viewcustomerrecord = () => {
  const location = useLocation();
  const data = location.state?.data;
  console.log(data, "data");

  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [documentContent, setDocumentContent] = useState(null);
  const [documentType, setDocumentType] = useState(null);
  const [ocrModal, setOCRModal] = useState(false);
  // Initialize activeTab from sessionStorage or default to 1
  const initialTab = parseInt(sessionStorage.getItem("activeTab"), 10) || 1;
  const [activeTab, setActiveTab] = useState(initialTab);
  const [tab2Records, setTab2Records] = useState([]);
  const [documnentTypee, setdocumnentTypee] = useState("");
  const [documentNum, setdocumentNum] = useState("");
  const [ocrData, setOcrData] = useState("");
  const [recordStatus, setRecordStatus] = useState("");
  const navigate = useNavigate();
  const menuLeft = useRef(null);
  const [abhaNum, setAbhanum] = useState("");
  const [name, setName] = useState("");
  const [abhaAddress, setAbhaAddress] = useState("");
  const [patientId, setPatientId] = useState("");
  const API_URL = process.env.REACT_APP_API_URL;

  const items = [
    {
      label: "Please Select the record type",
      items: [
        {
          label: "Prescription",
          command: () => handleNewRecord("Prescription"),
        },
        {
          label: "OP Consultation",
          command: () => handleNewRecord("OPConsultation"),
        },
        {
          label: "Diagnostic Report",
          command: () => handleNewRecord("DiagnosticReport"),
        },
        {
          label: "Invoice",
          command: () => handleNewRecord("Invoice"),
        },
      ],
    },
  ];

  const handleNewRecord = (selectedType) => {
    setdocumnentTypee(selectedType);
    setdocumentNum("");
    setOcrData("");
    setRecordStatus("");
    setOCRModal(true);
    setName(data?.firstName);
    setAbhaAddress(data?.preferredAbhaAddress);
    setPatientId(data?.patientId);
    setAbhanum(data?.abhaNumber);
  };

  useEffect(() => {
    validateToken(navigate);
  }, [navigate]);

  useEffect(() => {
    if (data?.patientId) {
      fetchCustomerRecords(data.patientId);
    }
  }, [data]);

  useEffect(() => {
    if (activeTab === 2 && data?.abhaNumber) {
      fetchTab2Records(data.abhaNumber);
    }
    // Save activeTab to sessionStorage whenever it changes
    sessionStorage.setItem("activeTab", activeTab);
  }, [activeTab, data]);

  const handleViewRecord = (record) => {
    navigate("/record-details", { state: { record } });
  };

  const fetchCustomerRecords = async (patientId) => {
    setLoading(true);
    try {
      const token = secureStorage.get("authToken");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      const response = await fetch(
        `${API_URL}abdm-data-share/get-documents?patientId=${patientId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-HIP-ID": secureStorage.get("clinic"),
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        setRecords(result.data || []);
      } else {
        console.error("Failed to fetch records:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching records:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDocumentContent = async (documentNumber) => {
    if (documentNumber) {
      setLoading(true);
      try {
        const token = secureStorage.get("authToken");
        if (!token) {
          console.error("Authentication token not found. Please log in again.");
          return;
        }

        const response = await fetch(
          `${API_URL}abdm-data-share/get-document?documentNumber=${documentNumber}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
              "X-HIP-ID": secureStorage.get("clinic"),
            },
          }
        );

        if (response.ok) {
          const result = await response.json();
          const base64Data = result.data || null;

          if (base64Data) {
            const contentType = detectContentType(base64Data);
            setDocumentContent(base64Data);
            setDocumentType(contentType);
            setModalOpen(true);
          } else {
            console.error("No data available for the document.");
          }
        } else {
          console.error("Failed to fetch document:", response.statusText);
        }
      } catch (error) {
        console.error("Error fetching document:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  const fetchTab2Records = async (abhaNumber) => {
    setLoading(true);
    try {
      const token = secureStorage.get("authToken");
      if (!token) {
        console.error("Authentication token not found. Please log in again.");
        return;
      }

      const response = await fetch(
        `${API_URL}hospital/get-abha-records?consentArtefactId=9fb1a62b-9169-4e70-a7b8-8db731f88cbb`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            "X-HIP-ID": secureStorage.get("clinic"),
          },
        }
      );

      if (response.ok) {
        const result = await response.json();
        setTab2Records(result.data || []);
      } else {
        console.error("Failed to fetch Tab 2 records:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching Tab 2 records:", error);
    } finally {
      setLoading(false);
    }
  };

  const detectContentType = (base64) => {
    if (base64.startsWith("JVBER")) {
      return "application/pdf";
    }
    if (base64.startsWith("/9j/")) {
      return "image/jpeg";
    }
    if (base64.startsWith("iVBOR")) {
      return "image/png";
    }
    return "unknown";
  };

  const closeModal = () => {
    setModalOpen(false);
    setDocumentContent(null);
    setDocumentType(null);
  };

  const abdmLink = (documentNumber, documentType, record) => {
    setdocumnentTypee(documentType);
    setdocumentNum(documentNumber);
    setOcrData(record);
    setOCRModal(true);
    setRecordStatus(record.status);
    setName(data?.firstName);
    setAbhaAddress(data?.preferredAbhaAddress);
    setPatientId(data?.patientId);
    setAbhanum(data?.abhaNumber);
  };

  const handleCloseOCR = () => {
    setOCRModal(false);
    fetchCustomerRecords(data?.patientId);
  };

  return (
    <div className="bg-[#F6F6F6] min-h-screen p-6">
      <div className="flex items-center justify-between mb-4">
        <button
          onClick={() => navigate(-1)}
          className="mb-4 flex items-center text-teal-700 hover:text-teal-900 font-medium"
        >
          <FaArrowLeft className="mr-2" /> Back
        </button>
        <div>
          <h1 className="text-3xl font-bold text-gray-800">
            View Patient's Record
          </h1>
        </div>

        <div className="flex gap-4">
          <button
            className="bg-teal-500 text-white px-4 py-2 font-semibold rounded-lg hover:bg-teal-600 flex items-center gap-2"
            onClick={() => fetchCustomerRecords(data?.patientId)}
          >
            <FaSyncAlt />
            <span>Refresh Records</span>
          </button>

          <Menu model={items} popup ref={menuLeft} id="popup_menu_left" />
          <button
            className="bg-teal-500 text-white px-4 py-2 font-semibold rounded-lg hover:bg-teal-600 flex items-center gap-2"
            onClick={(event) => menuLeft.current.toggle(event)}
            aria-controls="popup_menu_left"
            aria-haspopup
          >
            <FaPlus />
            <span>New Record</span>
          </button>
        </div>

      </div>


      {activeTab === 1 && (
        <div
          className="rounded-lg overflow-hidden shadow-md"
          style={{ backgroundColor: "#DEEBEC" }}
        >
          {loading ? (
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50">
              <div className="w-16 h-16 border-4 border-t-teal-600 border-gray-300 rounded-full animate-spin"></div>
            </div>
          ) : records.length === 0 ? (
            <p className="text-center py-4 text-gray-700">No records found</p>
          ) : (
            <table className="w-full table-auto">
              <thead className="bg-[#DEEBEC] border-b border-[#0F766E]">
                <tr>
                  <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    SL no
                  </th>
                  <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    Patient Name
                  </th>
                  <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    ABHA Address
                  </th>
                  <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    Document Type
                  </th>
                  <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    Generated Date
                  </th>
                  <th className="px-4 py-3 text-center text-[15px] font-semibold text-[#0F766E]">
                    ABHA Linking Status
                  </th>
                  <th className="px-4 py-3 text-center text-[15px] font-semibold text-[#0F766E]">
                    Action
                  </th>
                  {/* <th className="px-4 py-3 text-left text-[15px] font-semibold text-[#0F766E]">
                    View
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {records.map((record, index) => (
                  <tr
                    key={index}
                    className="bg-[#DEEBEC] border-b border-[#C6D9DB]"
                  >
                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                      {index + 1}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                      {`${data.firstName || ""} ${data.middleName || ""} ${data.lastName || ""}`.trim()}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                      {record.abhaAddress}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                      {record.documentType}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-gray-700">
                      {new Date(record.generatedDate).toLocaleString("en-IN", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: true,
                      })}
                    </td>
                    <td className="px-4 py-3 text-sm font-medium text-center relative group">
                      <img
                        src={record.status === "LINKED" ? verifiedIcon : notVerifiedIcon}
                        alt={record.status === "LINKED" ? "Linked" : "Not Linked"}
                        className="w-6 h-6 mx-auto"
                      />
                      <div
                        className={`absolute bottom-full mb-0 left-1/2 transform -translate-x-1/2 
                          text-white text-xs rounded-md px-2 py-1 opacity-0 group-hover:opacity-100 
                          transition-opacity z-10 pointer-events-none 
                          ${record.status === "LINKED" ? "bg-green-600" : "bg-red-400"}`}
                      >
                        {record.status === "LINKED" ? "Linked" : "Not Linked"}
                      </div>
                    </td>

                    {record.status === "OCR_COMPLETED" ? (
                      <h1
                        className="px-3 text-[#2B98D6] font-medium hover:underline cursor-pointer text-center"
                        onClick={() =>
                          abdmLink(
                            record.documentNumber,
                            record.documentType,
                            record
                          )
                        }
                      >
                        View/Edit
                      </h1>
                    ) : record.status === "LINKED" ? (
                      // <img
                      //   src={verifiedIcon}
                      //   alt="Linked"
                      //   className="w-6 h-6 mx-auto"
                      // />
                      <h1
                        className=" text-[#2B98D6] font-medium hover:underline cursor-pointer text-center"
                        onClick={() =>
                          abdmLink(
                            record.documentNumber,
                            record.documentType,
                            record
                          )
                        }
                      >
                        View
                      </h1>
                    ) : (
                      // <img
                      //   src={notVerifiedIcon}
                      //   alt="Not Linked"
                      //   className="w-6 h-6 mx-auto"
                      // />
                      <h1
                        className=" text-[#2B98D6] font-medium hover:underline cursor-pointer text-center"
                        onClick={() =>
                          abdmLink(
                            record.documentNumber,
                            record.documentType,
                            record
                          )
                        }
                      >
                        View
                      </h1>
                    )}
                    {/* <td
                      className="px-4 py-3 text-[#2B98D6] font-medium hover:underline cursor-pointer"
                      onClick={() =>
                        fetchDocumentContent(record.documentNumber)
                      }
                    >
                      View
                    </td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}

      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-3/4 max-w-4xl">
            <h2 className="text-2xl font-bold mb-4">Document Viewer</h2>
            {documentContent ? (
              <div>
                {documentType === "application/pdf" ? (
                  <iframe
                    src={`data:application/pdf;base64,${documentContent}`}
                    className="w-full h-96"
                    title="PDF Viewer"
                  ></iframe>
                ) : documentType.startsWith("image/") ? (
                  <img
                    src={`data:${documentType};base64,${documentContent}`}
                    alt="Document"
                    className="w-full h-[552px]"
                  />
                ) : (
                  <p>Unsupported file type.</p>
                )}
              </div>
            ) : (
              <p>No content available for this document.</p>
            )}
            <button
              className="mt-4 bg-teal-500 text-white px-4 py-2 rounded-md hover:bg-teal-600"
              onClick={closeModal}
            >
              Close
            </button>
          </div>
        </div>
      )}

      <Dialog
        header={documnentTypee || "Record"}
        visible={ocrModal}
        onHide={() => {
          if (!ocrModal) return;
          setOCRModal(false);
          // fetchCustomerRecords();
        }}
        style={{ width: "90vw" }}
        breakpoints={{ "960px": "75vw", "641px": "100vw" }}
      >
        <DocumentTypeOCR
          docType={documnentTypee}
          docNum={documentNum}
          ocr={ocrData}
          status={recordStatus}
          onClose={handleCloseOCR}
          abha={abhaNum}
          name={name}
          patientId={patientId}
          abhaAddress={abhaAddress}
        />
      </Dialog>
    </div>
  );
};

export default Viewcustomerrecord;
